import { createSlice, PayloadAction } from "@reduxjs/toolkit";

interface GeneralState {
  alertMessage: string;
  alertType: "success" | "error";
}

const initialState: GeneralState = {
  alertMessage: "",
  alertType: "error",
};

const generalSlice = createSlice({
  name: "general",
  initialState,
  reducers: {
    setGeneralAlertMessage: (state, action: PayloadAction<{ message: string; type: "error" | "success" }>) => {
      state.alertMessage = action.payload.message;
      state.alertType = action.payload.type;
    },
    clearAlert: (state) => {
      state.alertMessage = "";
      state.alertType = "error";
    },
  },
});

export const { setGeneralAlertMessage, clearAlert } = generalSlice.actions;

export default generalSlice.reducer;
